import * as React from 'react';
import { SideNavBranch, findParentBranches, SideNavItems } from './SpsSideNav';
import clsx from 'clsx';
import { useState } from 'react';

export interface SpsSideNavBranchProps {
  branch: SideNavBranch;
  activeBranch: string;
  setActiveBranch: (activeChildBranchName: string) => void;
}

export const SpsSideNavBranch: React.FC<SpsSideNavBranchProps> = ({
                                                                    branch,
                                                                    setActiveBranch,
                                                                    activeBranch,
                                                                  }) => {
  const [isBranchExpanded, setIsBranchExpanded] = useState(
    branch.expanded || false
  );

  return (
    <ul
      className={clsx(
        'sps-side-nav__branch',
        branch.name === activeBranch && 'sps-side-nav__branch--active'
      )}
    >
      <li
        className={clsx(
          'sps-side-nav__leaf',
          branch.name === activeBranch && 'sps-side-nav__leaf--active'
        )}
      >
                <span
                  className="sps-side-nav__link"
                  onClick={(): void => {
                    setIsBranchExpanded(!isBranchExpanded);
                    if (!branch.subNavItems) { setActiveBranch(branch.name); }
                  }}
                  onKeyDown={(event): void => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.stopPropagation();
                      event.preventDefault();
                      setIsBranchExpanded(!isBranchExpanded);
                      if (!branch.subNavItems) { setActiveBranch(branch.name); }
                    }
                  }}
                  role="tab"
                  tabIndex={0}
                >
                    {branch.subNavItems && (
                      <i
                        className={clsx(
                          'sps-icon sps-side-nav__toggle',
                          isBranchExpanded
                            ? 'sps-icon-chevron-down'
                            : 'sps-icon-chevron-right'
                        )}
                      />
                    )}
                  <span className="sps-side-nav__link-title">
                        {branch.name}
                    </span>
                    <div
                      className="sps-side-nav__link-tag"
                      style={{ marginTop: '-2px' }}
                    >
                        {branch.tag && (
                          <span
                            className={`sps-tag sps-tag--${branch.tag}`}
                          >
                                {branch.tagContent}
                            </span>
                        )}
                    </div>
                </span>
        {branch.subNavItems &&
        isBranchExpanded &&
        branch.subNavItems.map((subNav: SideNavItems) => (
          <SpsSideNavBranch
            branch={{
              ...subNav,
              expanded: findParentBranches(
                subNav.subNavItems,
                activeBranch
              ),
            }}
            setActiveBranch={setActiveBranch}
            activeBranch={activeBranch}
            key={subNav.name}
          />
        ))}
      </li>
    </ul>
  );
};
